import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import { Tabs } from '@/exceed';

import { Loading } from 'uikit/loaders';

import styles from '../styles/videoAdminBody.module.scss';

const VideosAdminBody = ({
  isLoading,
  tabs,
  url,
  activeId,
}) => (
  isLoading ? <Loading className={styles.loader} /> : (
    <Tabs
      bodyClassName={classnames(styles.body, {
        [styles.hasMaxWidth]: activeId !== 'compose',
      })}
      navClassName={styles.hasMaxWidth}
      queryParamsToPersist={['version_id']}
      url={url}
      activeId={activeId}
      tabs={tabs}
    />
  )
);

VideosAdminBody.defaultProps = {
  isLoading: false,
  tabs: [],
  url: '/videos',
  activeId: 'on-demand',
};

VideosAdminBody.propTypes = {
  isLoading: PropTypes.bool,
  tabs: PropTypes.arrayOf(PropTypes.shape({})),
  url: PropTypes.string,
  activeId: PropTypes.string,
};

export default React.memo(VideosAdminBody);
